import type { GradientOverlayData } from "@/common/lib/types";

const DEFAULT_GRADIENT =
  "linear-gradient(to top, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 50%)";

function rgba(color: GradientOverlayData["startColor"]): string | undefined {
  const r = color?.rgb?.r;
  const g = color?.rgb?.g;
  const b = color?.rgb?.b;
  const a = color?.rgb?.a ?? 1;
  if (r === undefined || g === undefined || b === undefined) return undefined;
  return `rgba(${r}, ${g}, ${b}, ${a})`;
}

export function buildGradientOverlayCss(
  overlay?: GradientOverlayData | null,
): string {
  if (!overlay) return DEFAULT_GRADIENT;

  const start = rgba(overlay.startColor);
  const end = rgba(overlay.endColor);

  if (!start && !end) return DEFAULT_GRADIENT;

  return `linear-gradient(to top, ${start ?? "transparent"} 0%, ${end ?? "transparent"} 50%)`;
}
